import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { useOnClose } from '@core/js/components/common/PopupManager';

import { I18n } from '@interlayer/js/components/common/I18n';
import { ManagedPopup } from '@interlayer/js/components/common/Popup/ManagedPopup';

import { useTranslations } from '@core/js/hooks/i18n';

import { useNavigateToSlotPage } from '@interlayer/js/app/components/main/Registration/components/templates/SlotReg/components/slotUpgrade/hooks/useNavigateToSlotPage';
import { useFinishLogin } from '@interlayer/js/app/components/main/Registration/hooks/useFinishLogin';
import { setIsLoadingSendForm, setIsRegistrationInProcess } from '@interlayer/js/app/store/reducers/Registration/actions';

import styleReg from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/OnlineReg.scss';

export const AlreadySlotClubMemberPopup: React.FC<{ id: string; userName: string }> = ({ id, userName }) => {
    const onClosePopup = useOnClose(id);
    const t = useTranslations('playtech.mobile.system.registration.slotUpgrade.alreadySlotClubMemberPopup.');
    const navigateToSlotPage = useNavigateToSlotPage();
    const finishLogin = useFinishLogin();
    const dispatch = useDispatch();

    const handlerNavigateToSlotPage = useCallback(async () => {
        dispatch(setIsRegistrationInProcess(true));
        dispatch(setIsLoadingSendForm(true));

        onClosePopup();

        await finishLogin({ userName, isNavigateAfterLogin: false });

        navigateToSlotPage();

        dispatch(setIsLoadingSendForm(false));
        dispatch(setIsRegistrationInProcess(false));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, navigateToSlotPage, onClosePopup, userName]);

    return (
        <ManagedPopup
            withLogo
            fullscreen
            onClose={handlerNavigateToSlotPage}
            className={styleReg.modal}
            buttons={[{
                text: t('button'),
                onClick: handlerNavigateToSlotPage
            }]}
        >
            <div className={styleReg.modalContent}>
                <I18n
                    t={t}
                    tKey="title"
                    className={styleReg.modalTitle}
                />

                <I18n
                    t={t}
                    tKey="text"
                    className={styleReg.modalText}
                />
            </div>
        </ManagedPopup>
    );
};
